import customerImage from "./assets/customerr.webp";
import handImage from "./assets/customerr.jpg";
import laptopGirlImage from "./assets/girl-laptop.png";
import sixPlusImage from "./assets/6plus.png";
import creativityImage from "./assets/creativity.png";
import underline from "./assets/underlinea.png";

const HeroSection = () => {
  return (
    <section className="relative w-full bg-white font-poppins px-4 sm:px-6 lg:px-8 py-16 overflow-hidden">
      <div className="relative max-w-screen-xl mx-auto h-auto">
        {/* Text Block */}
        <div className="absolute inset-x-0 top-0 z-20 text-center mt-[-4rem] sm:mt-[-5rem] md:mt-[-6rem]">
          <p className="text-green-600 font-medium text-base">
            Our journey started with newbies
          </p>
          <img
            src={underline}
            alt="underline"
            className="mx-auto mt-2 w-36 h-3"
          />
          <h2 className="text-4xl sm:text-5xl font-semibold mt-4 text-gray-900">
            The Lentera Story
          </h2>
          <p className="mt-4 text-gray-500 text-base sm:text-lg max-w-2xl mx-auto px-2">
            We value strong client partnerships—and it shows. No one delivers
            innovative IT solutions quite like our team.
          </p>
        </div>

        {/* Desktop Grid */}
        <div className="hidden lg:grid grid-cols-5 gap-x-4 gap-y-6 mt-16">
          {/* Card 1 */}
          <div className="bg-[#DDF5E6] rounded-2xl p-4 flex flex-col justify-between items-center text-center h-[22rem]">
            <p className="text-lg font-medium">
              100+
              <br />
              Delighted customers
            </p>
            <img
              src={customerImage}
              alt="Customer"
              className="top-20 w-4/4 h-auto object-contain"
            />
          </div>

          {/* Card 2 (staggered down 16%) */}
          <div className="bg-[#F5F5F5] relative top-[60%] rounded-2xl p-4 flex flex-col justify-between items-center text-center h-[21rem]">
            <p className="text-lg font-medium">
              Professional minds,
              <br />
              simplified software
            </p>
            <img
              src={laptopGirlImage}
              alt="Laptop Girl"
              className="top-20 w-4/4  h-auto object-contain"
            />
          </div>

          {/* Card 3 (staggered down more) */}
          <div className="bg-[#FFE7F1] relative top-[90%] rounded-2xl p-4 flex flex-col justify-between items-center text-center h-[15rem]">
            <p className="text-lg font-medium">
              Delivering innovation
              <br />
              6+ years
            </p>
            <img
              src={sixPlusImage}
              alt="6+ Years"
              className="top-20 w-4/4  h-auto object-contain"
            />
          </div>

          {/* Card 4 (same as card 2) */}
          <div className="bg-[#FFF1E1] relative top-[60%] rounded-2xl p-4 flex flex-col justify-between items-center text-center h-[21rem]">
            <p className="text-lg font-medium">
              Driven by a culture
              <br />
              of creativity
            </p>
            <img
              src={creativityImage}
              alt="Creativity"
              className="top-0 w-full h-auto object-contain"
            />
          </div>

          {/* Card 5 */}
          <div className="bg-[#E5D9FB] rounded-2xl p-4 flex flex-col justify-between items-center text-center h-[22rem]">
            <p className="text-lg font-medium">
              Passion-driven,
              <br />
              united by code
            </p>
            <img
              src={handImage}
              alt="Hands"
              className="top-20 w-full h-auto object-contain"
            />
          </div>

          {/* Small Card 6 */}
          <div className="relative flex flex-wrap justify-center gap-6">
            {/* Left Card */}
            <div className="bg-[#FFE1E1] w-64 h-40 rounded-2xl p-4 flex flex-col justify-center items-center text-center shadow-md">
              <h3 className="text-2xl font-semibold">100%</h3>
              <p className="text-base text-center">
                On time delivery accuracy
                <br />
                in all worked projects
              </p>
            </div>
          </div>

          {/* Small Card 7 (staggered right bottom) */}
          <div className="bg-[#D7EEFF]  w-64 h-40 absolute right-[-20px] bottom-4 rounded-2xl p-4 flex flex-col justify-center items-center text-center">
            <h3 className="text-2xl font-semibold">24/7</h3>
            <p className="text-base">
              Providing valuable customer
              <br />
              support service
            </p>
          </div>
        </div>

        {/* Mobile Layout */}
        <div className="lg:hidden mt-12 space-y-8">
          {[
            customerImage,
            laptopGirlImage,
            sixPlusImage,
            creativityImage,
            handImage,
          ].map((img, idx) => (
            <div
              key={idx}
              className={`bg-white rounded-2xl p-4 flex flex-col justify-between items-center text-center h-auto ${
                idx >= 1 && "mt-10"
              }`}
            >
              {/* Use proper conditional content */}
              <img src={img} alt="" className="w-3/4 h-auto object-contain" />
            </div>
          ))}
          {/* Small Cards below */}
          <div className="flex flex-wrap justify-center gap-6">
            <div className="bg-[#FFE1E1] w-64 h-42 rounded-2xl p-4 flex flex-col justify-center items-center text-center shadow-md">
              <h3 className="text-2xl font-semibold">100%</h3>
              <p className="text-base text-center">
                On time delivery accuracy
                <br />
                in all worked projects
              </p>
            </div>

            <div className="bg-[#D7EEFF] w-64 h-40 rounded-2xl p-4 flex flex-col justify-center items-center text-center shadow-md">
              <h3 className="text-2xl font-semibold">24/7</h3>
              <p className="text-base mt-2 leading-snug text-center">
                Providing valuable customer
                <br />
                support service
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
